<template>
  <div class="homeAppBanner">
    <div
      v-if="getWidgetData?.length > 0 && cta"
      class="horizontal-banners mb16 plr12"
      id="undefined-horizontal-banner-app-install"
    >
      <!-- Intersection Observer -->
      <Observer
        :options="{ rootMargin: '-50px' }"
        @intersect.once="itisvisible"
      />
      <div :style="getStyle" class="homeAppBanner__item flex-column justify-content-between pr" @click.prevent="handleCtaClick($event)">
        <img class="pa" :src="bannerImage" alt="banner image" />
        <div class="pb12 plr16 pt24">
        <div>
          <div class="fs-18 lh24 item_title pb12" :style="getTitleStyle">
            {{ getWidgetData[0]?.title }}
          </div>
          <div
            v-html="getWidgetData[0]?.subTitle"
            class="pl16 content pb10"
            :style="getSubTitleStyle"
          ></div>
        </div>
        <button class="cta bold">
          {{ cta }}
        </button>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction } from "../helpers/storeKeys";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";

export default {
  name: "DynamicAppBanner",
  props: ["dataApi", "moduleProps"],
  components: {
    Observer,
  },
  data() {
    return {
      modulePropsData: {},
      widgetType: "",
      bannerImage: "",
      cta: "",
      redirectToAppUrl: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.widgetType = this.modulePropsData?.type || "";
    this.redirectToAppUrl = this.modulePropsData?.redirectToAppUrl || "";
  },
  methods: {
    itisvisible() {
      if (this.getWidgetData.length > 0) {
        this.eventFunction(false, {});
      }
    },
    eventFunction(isClicked = false, eObj = {}) {
      let eventType = isClicked ? "Click" : "ngh appInstall impression";
      let userAction = isClicked ? "click" : "ngh appInstall impression";
      let preEventObj = { category: this.cta.toLowerCase(), ...eObj };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "app install banner",
        "5",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleCtaClick() {
      this.eventFunction(true, {});
      if (this.redirectToAppUrl) {
        window.location.href = this.redirectToAppUrl;
      }
    },
  },
  computed: {
    getWidgetData() {
      const { type } = this.modulePropsData;
      let tempData = this.$store.state.User?.staticWidgetData;
      let data = [];
      let key = type ? type : "";
      if (key) {
        data = tempData[key] || [];
      }

      if (data?.length) {
        this.bannerImage = data[0]?.icon || ""; 
        this.cta = data[0]?.props?.cta || "";
      }
      return data;
    },
    getStyle() {
      let color = this.modulePropsData?.color;
      return {
        color: color + " !important",
      };
    },
    getTitleStyle() {
      let maxWidth = this.modulePropsData?.titleWidth;
      let _ = {
        maxWidth: maxWidth,
      };

      return _;
    },
    getSubTitleStyle() {
      let maxWidth = this.modulePropsData?.subTitleWidth;
      let _ = {
        maxWidth: maxWidth,
      };

      return _;
    },
  },
};
</script>
